<template>
  <div>
    <v-card class="rounded-lg" elevation="0" outlined>
      <v-col cols="12" class="pa-4">
        <v-img
          :src="$vuetify.theme.dark ? require('@/assets/images/logo_dinamo_high_light.png') : require('@/assets/images/logo_dinamo_high_dark.png')"
        />
      </v-col>
      <v-card-text>
        <v-form @submit.prevent="submit">
          <v-text-field
            id="username_text_field"
            :class="$vuetify.theme.dark ? 'autofill-fix-dark' : 'autofill-fix'"
            prepend-icon="person"
            :label="$tc('username')"
            :hint="$tc('username_hint')"
            type="text"
            v-model="username"
            :error-messages="usernameErrors"
            @input="$v.username.$touch()"
            @blur="$v.username.$touch()"
            color="text_secondary"
          />
          <v-text-field
            id="password_text_field"
            :class="$vuetify.theme.dark ? 'autofill-fix-dark' : 'autofill-fix'"
            prepend-icon="password"
            :label="$tc('password')"
            :hint="$tc('password_hint')"
            type="password"
            autocomplete="current-password"
            v-model="password"
            :error-messages="passwordErrors"
            @input="$v.password.$touch()"
            @blur="$v.password.$touch()"
            color="text_secondary"
          />
          <v-text-field
            id="otp_text_field"
            :class="$vuetify.theme.dark ? 'autofill-fix-dark' : 'autofill-fix'"
            prepend-icon="pin"
            :label="$tc('otp')"
            :hint="$tc('otp_hint')"
            type="text"
            v-model="otp"
            :error-messages="otpErrors"
            @input="$v.otp.$touch()"
            @blur="$v.otp.$touch()"
            color="text_secondary"
          />
          <v-row class="my-2" no-gutters>
            <v-tooltip top>
              <template #activator="{ on }">
                <v-btn
                  id="login_info"
                  icon
                  v-on="on"
                  class="mx-0"
                  @click="showInfoDialog = true"
                >
                  <v-icon color="grey">
                    info
                  </v-icon>
                </v-btn>
              </template>
              <span>{{ $tc('login_info') }}</span>
            </v-tooltip>

            <v-spacer />

            <v-btn
              id="login_btn"
              type="submit"
              class="mx-0"
              :disabled="$v.$invalid"
              :dark="!$v.$invalid"
            >
              {{ $t('login') }}
            </v-btn>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>

    <info-dialog
      :open="showInfoDialog"
      @close="showInfoDialog = false"
    />
  </div>
</template>

<script>
import { required, minLength, maxLength } from 'vuelidate/lib/validators'
import InfoDialog from './InfoDialog.vue'

export default {
  components: {
    InfoDialog
  },
  data () {
    return {
      showInfoDialog: false
    }
  },
  computed: {
    username: {
      get () {
        return this.$store.state.auth.username
      },
      set (val) {
        return this.$store.commit('auth/SET_USERNAME', val)
      }
    },
    password: {
      get () {
        return this.$store.state.auth.password
      },
      set (val) {
        return this.$store.commit('auth/SET_PASSWORD', val)
      }
    },
    otp: {
      get () {
        return this.$store.state.auth.otp
      },
      set (val) {
        return this.$store.commit('auth/SET_OTP', val)
      }
    },
    error () {
      // return this.$v.$anyError
      return this.$store.state.auth.error.status
    },
    usernameErrors () {
      const errors = []
      if (!this.$v.username.$dirty) return errors
      // !this.$v.username.minLength &&
      //   errors.push(
      //     this.$t('$validation.min_length', {
      //       num: this.$v.username.$params.minLength.min
      //     })
      //   )
      // !this.$v.username.maxLength &&
      //   errors.push(
      //     this.$t('$validation.max_length', {
      //       num: this.$v.username.$params.maxLength.max
      //     })
      //   )
      !this.$v.username.required && errors.push(this.$t('$validation.required'))
      return errors
    },
    passwordErrors () {
      const errors = []
      if (!this.$v.password.$dirty) return errors
      // !this.$v.password.minLength &&
      //   errors.push(
      //     this.$t('$validation.min_length', {
      //       num: this.$v.password.$params.minLength.min
      //     })
      //   )
      // !this.$v.password.maxLength &&
      //   errors.push(
      //     this.$t('$validation.max_length', {
      //       num: this.$v.password.$params.maxLength.max
      //     })
      //   )
      !this.$v.password.required && errors.push(this.$t('$validation.required'))
      return errors
    },
    otpErrors () {
      const errors = []
      if (!this.$v.otp.$dirty) return errors
      !this.$v.otp.minLength &&
        errors.push(
          this.$t('$validation.min_length', {
            num: this.$v.otp.$params.minLength.min
          })
        )
      !this.$v.otp.maxLength &&
        errors.push(
          this.$t('$validation.max_length', {
            num: this.$v.otp.$params.maxLength.max
          })
        )
      return errors
    }
  },
  validations: {
    username: {
      required
      // minLength: minLength(2),
      // maxLength: maxLength(150)
    },
    password: {
      required
      // maxLength: maxLength(16)
      // minLength: minLength(6)
    },
    otp: {
      minLength: minLength(4),
      maxLength: maxLength(8)
    }
  },
  methods: {
    async submit () {
      this.$v.$touch()
      const isValid = !this.$v.$invalid
      try {
        if (isValid) {
          const res = await this.$store.dispatch('auth/doLogin')

          if (res && res.pwd_expired > 0) {
            return this.$router.push({ name: 'renewPassword' })
          }

          // if (this.$route.query.to) {
          //   return this.$router.push(this.$route.query.to)
          // }

          return this.$router.push({ name: 'home' })
        }
      } catch (err) {
        const errObj = this.$store.getters['error/getErrorObj'](err)
        this.$notify.hsmError(errObj, err)
      }
    }
  }
}
</script>

<style scoped>

</style>
